import React, { useEffect, useRef, useState } from 'react';
import { motion, useDragControls } from 'framer-motion';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Interweave } from 'interweave';

import useConfigs from '../../hooks/useConfigs';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faX,
  faLocationDot,
  faEnvelope,
  faUser,
  faPhone,
  faMessage,
} from '@fortawesome/free-solid-svg-icons';
import { faComments } from '@fortawesome/free-regular-svg-icons';
import {
  faWhatsapp,
  faTiktok,
  faTwitter,
  faInstagram,
  faLinkedin,
  faFacebook,
  faTwitch,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { Slideshow } from '@material-ui/icons';

library.add(
  faWhatsapp,
  faTiktok,
  faTwitter,
  faInstagram,
  faLinkedin,
  faFacebook,
  faTwitch,
  faYoutube,
  faX,
  faLocationDot,
  faEnvelope,
  faUser,
  faPhone,
  faComments,
  faMessage
);

// ##### Estilos #####

const SpanArrowLeft = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 30px;
  background-color: #fff;
  // border: 1px solid #05aaaa;
  box-shadow: 0 0 20px -5px #5A6169;
  transition: all 0.5s;

  position: absolute;
  left: 10px;
  top: 150;
  z-index: 2;
  filter: grayscale(0.8);

  &:hover {
    color: #fff;
    cursor: pointer;
    transform: scale(1.05);
    filter: brightness(1);
  }

  @media (max-width: 768px) {
    top: 80;
    transform: scale(0.8);

    &:hover {
      transform: scale(0.9);
    }
  }

`;

const SpanArrowRight = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 30px;
  background-color: #fff;
  // border: 1px solid #05aaaa;
  box-shadow: 0 0 20px -5px #5A6169;
  transition: all 0.5s;

  position: absolute;
  left: calc(96% - 30px);
  top: 150;
  z-index: 2;
  filter: grayscale(0.8);

  &:hover {
    color: #fff;
    cursor: pointer;
    transform: scale(1.05);
    filter: brightness(1);
  }

  @media (max-width: 768px) {
    top: 80;
    transform: scale(0.8);

    &:hover {
      transform: scale(0.9);
    }
  }

`;

const MotionDivCarousel = styled(motion.div)`
  cursor: grab;
  overflow: hidden !important;
  border-radius: 3px;
  margin: 2rem 0;
  position: relative;
  width: 100%;
  margin-bottom: 5rem;

  .inner-carousel-icon {
    display: flex;
    padding: 0.5rem 0rem;
    background-color: #red;
    transform: ${(props) =>
      `translateX(-${props.translateXwidth}`})px) translateY(0px) translateZ(0px) !important;
  }
`;

const InnerCarouselIcon = styled(motion.div)`
  display: flex;
  padding: 0.5rem 0rem;
`;

const MotionDivItems = styled(motion.div)`
  min-width: 30rem;
  width: 33%;
  margin: 0 10px;
  border-radius: 40px;
  overflow: hidden !important;
  // transform: ${(props) => `translateX(-${props.translateX})`};
  // overflow-y: scroll !important;

  img {
    pointer-events: none;
    width: 100%;
    border-radius: 77% 20% / 10%;
  }
`;

const CardValoresCorporativos = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  border-radius: 15px;
  margin: 2rem auto;
  transition: 0.5s ease;
  padding: 0 1rem 2rem 1rem;
  min-width: 30rem;
  width: 33%;
  height: 90%;
  max-height: 500px;

  .icon-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3rem;
    max-width: 15rem;
    min-height: 15rem;
    border-radius: 7.5rem;
    background-color: #05aaaa;
    overflow: hidden;

    img {
      width: 80%;
      height: auto;
    }
  }
`;

const ValoresCorporativosDesc = styled.div`
  h3 {
    color: ${(props) => props.colortitle};
    font-size: ${(props) => 22 * props.fontsizemultiplier};
    font-weight: bold;
    padding: 0rem 1rem;
  }

  p {
    text-align: justify;
    color: ${(props) => props.colortipografia} !important;
    // padding: 1rem 1rem 0 1rem;
    font-size: ${(props) => 15 * props.fontsizemultiplier} !important;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    line-clamp-: 3;
    overflow: hidden !important;

    span {
      text-align: justify;
      color: ${(props) => props.colortipografia} !important;
      font-size: ${(props) => 15 * props.fontsizemultiplier} !important;
    }
  }
`;
export const HorizontalCarouselIcon = ({ data }) => {
  const { fontSizeMultiplier, activeTheme } = useConfigs();
  const [arrowValueWidth, setArrowValueWidth] = useState(0);

  const [width, setWidth] = useState(0);
  const carousel = useRef();

  const carouselWidth = setTimeout(() => {
    setWidth(carousel.current.scrollWidth - carousel.current.offsetWidth);
  }, 3000);

  useEffect(() => {
    setWidth(carousel.current.scrollWidth - carousel.current.offsetWidth);
  }, [carouselWidth]);

  const colorTitle = {
    DEFAULT: activeTheme?.color_base_ppal,
    ROSADO: activeTheme?.color_base_blanco,
    DARK: activeTheme?.color_base_blanco,
  };

  const colorTipografia = {
    DEFAULT: activeTheme?.color_base_tipografia,
    ROSADO: activeTheme?.color_base_blanco,
    DARK: activeTheme?.color_base_blanco,
  };

  const [positionItemCarousel, setPositionItemCarousel] = useState(0);

  const onRigth = () => {
    let newValueArrow =
      arrowValueWidth + carousel?.current?.scrollWidth / data?.length + 20;

    if (carousel?.current?.scrollWidth > carousel?.current?.offsetWidth) {
      setArrowValueWidth(newValueArrow);
    }
    setPositionItemCarousel(positionItemCarousel + 1);
  };

  const onLeft = () => {
    let newValueArrow =
      arrowValueWidth - carousel?.current?.scrollWidth / data?.length - 10;

    if (
      carousel?.current?.scrollWidth >= carousel?.current?.offsetWidth &&
      arrowValueWidth > 0
    ) {
      setArrowValueWidth(newValueArrow > 0 ? newValueArrow : 0);
      return;
    }

    if (arrowValueWidth < 0) {
      setArrowValueWidth(0);
      return;
    }

    setPositionItemCarousel(positionItemCarousel - 1);
  };

  return (
    <div style={{ position: 'relative' }}>
      <SpanArrowLeft onClick={onLeft}>
        <img
          src='img/Iconos/SVG/flecha-izquierda.svg'
          alt='flecha izquierda'
          onClick={onLeft}
        />
      </SpanArrowLeft>
      <SpanArrowRight onClick={onRigth}>
        <img
          src='img/Iconos/SVG/flecha-derecha.svg'
          alt='flecha derecha'
          onClick={onRigth}
        />
      </SpanArrowRight>
      <MotionDivCarousel ref={carousel}>
        <InnerCarouselIcon
          drag='x'
          dragConstraints={{ right: 0, left: -width - 50 }}
          whileTap={{ cursor: 'grabing' }}
          style={{ x: Number(`-${arrowValueWidth}`) }}
        >
          {data
            ? data?.map(
                (d, i) =>
                  d?.activo && (
                    <MotionDivItems key={d.name + '-' + i}>
                      <CardValoresCorporativos>
                        <div className='icon-container'>
                          <img src={d.imagen} alt='icon' />
                        </div>
                        <ValoresCorporativosDesc
                          fontsizemultiplier={fontSizeMultiplier}
                          colortitle={colorTitle[activeTheme?.nombre]}
                          colortipografia={colorTipografia[activeTheme?.nombre]}
                        >
                          <h3>{d.titulo}</h3>
                          <p>
                            <Interweave content={d.texto_completo} />
                          </p>
                        </ValoresCorporativosDesc>
                      </CardValoresCorporativos>
                    </MotionDivItems>
                  )
              )
            : 'loading'}
        </InnerCarouselIcon>
      </MotionDivCarousel>
    </div>
  );
};

HorizontalCarouselIcon.propTypes = {
  data: PropTypes.array,
};
